import React from "react";

const WebinarSponsorsRepresentative = ({ sponsors }) => {
  return (
    <div>
      <div style={{ marginBottom: 10 }}>Sponsored by:</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {sponsors.map(({ avatar_url, first_name, last_name }, idx) => (
          <div
            key={idx}
            style={{ display: "flex", gap: 8, alignItems: "center" }}
          >
            <div style={{ width: 75, height: 75 }}>
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                alt="representative-logo"
                src={avatar_url}
              />
            </div>
            <div>
              {first_name} {last_name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebinarSponsorsRepresentative;



// WEBPACK FOOTER //
// ./src/components/WebinarSponsorsRepresentative/index.jsx